class LightSource {
    constructor(viewer, color) {
        this.sourceModelId = null;
        this.color = color;
        this.viewer = viewer;
        this.sourceModelId = null;
    }
    remove() {
        this.light && this.viewer.delete_light(this.light);
        this.sourceModelId && this.viewer.delete_object(this.sourceModelId);
    }
    setIntensity(intensity) {
        if (this.light) {
            this.light.intensity = intensity;
        }
    }
    setColor(color) {
        if (this.light) {
            this.light.color = { r: color.r, g: color.g, b: color.b };
        }
    }
    setSourceModelId(sourceModelId) {
        this.sourceModelId = sourceModelId;
    }
}
export default LightSource;
//# sourceMappingURL=LightSource.js.map